import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/progress.svg'
import _imports_1 from '@/assets/icons/arrow-right-up.svg'


const _hoisted_1 = { class: "w-full mt-8" }
const _hoisted_2 = { class: "flex items-center justify-between mb-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "in progress"
}, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("IN PROGRESS")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" add ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "open",
  class: "opacity-70"
}, null, -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "flex flex-row"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Block Explorer")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "open",
  class: "ml-2 cursor-pointer"
}, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_status_header = _resolveComponent("status-header")!
  const _component_copy_hash = _resolveComponent("copy-hash")!
  const _component_n_text = _resolveComponent("n-text")!
  const _component_detail = _resolveComponent("detail")!
  const _component_n_time = _resolveComponent("n-time")!
  const _component_n_divider = _resolveComponent("n-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_status_header, {
      status: _ctx.status,
      "confirm-at": _ctx.confirmAt,
      "destination-network": _ctx.destNet
    }, null, 8 /* PROPS */, ["status", "confirm-at", "destination-network"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_copy_hash, {
          class: "text-xl font-medium",
          address: _ctx.$route.params.id
        }, null, 8 /* PROPS */, ["address"]),
        (_ctx.status >= 0 && _ctx.status < 4)
          ? (_openBlock(), _createBlock(_component_n_text, {
              key: 0,
              class: "flex flex-row text-sm text-white opacity-60 font-medium"
            }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createCommentVNode(" tx is dispatched but not processed "),
                _createVNode(_component_n_text, { class: "uppercase ml-2" }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true)
      ]),
      _createVNode(_component_detail, { title: "AMOUNT" }, {
        default: _withCtx(() => [
          (_ctx.amount)
            ? (_openBlock(), _createBlock(_component_n_text, {
                key: 0,
                class: "flex flex-row"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.amount) + " " + _toDisplayString(_ctx.tokenSymbol), 1 /* TEXT */),
                  _createElementVNode("span", {
                    class: "opacity-70 flex flex-row ml-2 cursor-pointer",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addToken && _ctx.addToken(...args)))
                  }, _hoisted_7)
                ]),
                _: 1 /* STABLE */
              }))
            : (_openBlock(), _createBlock(_component_n_text, { key: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.nullVal), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }))
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_detail, {
        title: `ORIGIN: ${_ctx.originNet.toUpperCase()}`
      }, {
        default: _withCtx(() => [
          (_ctx.originAddr)
            ? (_openBlock(), _createBlock(_component_copy_hash, {
                key: 0,
                address: _ctx.originAddr
              }, null, 8 /* PROPS */, ["address"]))
            : (_openBlock(), _createBlock(_component_n_text, { key: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.nullVal), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["title"]),
      _createVNode(_component_detail, {
        title: `DESTINATION: ${_ctx.destNet.toUpperCase()}`
      }, {
        default: _withCtx(() => [
          (_ctx.destAddr)
            ? (_openBlock(), _createBlock(_component_copy_hash, {
                key: 0,
                address: _ctx.destAddr
              }, null, 8 /* PROPS */, ["address"]))
            : (_openBlock(), _createBlock(_component_n_text, { key: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.nullVal), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["title"]),
      _createVNode(_component_detail, { title: "TRANSFER INITIATED" }, {
        default: _withCtx(() => [
          (_ctx.timeSent)
            ? (_openBlock(), _createBlock(_component_n_time, {
                key: 0,
                time: _ctx.timeSent,
                format: "yyyy-MM-dd hh:mm"
              }, null, 8 /* PROPS */, ["time"]))
            : (_openBlock(), _createBlock(_component_n_text, { key: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.nullVal), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }))
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_n_divider),
      _createCommentVNode(" link to block explorer "),
      (_ctx.explorerLink)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("a", {
              href: _ctx.explorerLink,
              class: "flex items-center hover:underline",
              target: "_blank"
            }, [
              _createVNode(_component_n_text, null, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1 /* STABLE */
              }),
              _hoisted_11
            ], 8 /* PROPS */, _hoisted_9)
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}